// extracted by mini-css-extract-plugin
export default {"iconButton":"icon-button-new-design_iconButton__BkztQ"};